export default __webpack_public_path__ + "static/media/odznaka-2.9d206ae3.svg";